import React, { Component } from 'react';
import PropTypes from 'prop-types';
import defaultJobImage from '../../../images/default_skill.jpeg';
import spinner from '../../../images/spinner.gif';
import Delete from '../../common/forms/buttons/Delete';

export default class ActiveWorkerSkill extends Component {
  static propTypes = {
    workerId: PropTypes.number.isRequired,
    skill: PropTypes.object.isRequired,
    skillLevels: PropTypes.array.isRequired,
    getWorkerSkillsAction: PropTypes.func.isRequired,
    changeWorkerSkillAction: PropTypes.func.isRequired,
    deleteWorkerSkillAction: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      isEditing: false,
      isLoading: false,
      skillLevel: props.skill.ranking_number,
      initialSkillLevel: props.skill.ranking_number
    };
  }

  editSkill = () => {
    this.setState({
      isEditing: true
    });
  };

  cancelEditingSkill = () => {
    this.setState({
      isEditing: false,
      skillLevel: this.state.initialSkillLevel
    });
  };

  removeActiveSkill = () => {
    const { deleteWorkerSkillAction, getWorkerSkillsAction, workerId, skill } = this.props;
    this.setState({
      isLoading: true
    });
    deleteWorkerSkillAction(skill.id).then(
      () => getWorkerSkillsAction(workerId).then(
        () => {
          this.setState({
            isLoading: false
          });
        }
      )
    );
  };

  submitEditing = () => {
    const { changeWorkerSkillAction, getWorkerSkillsAction, skill, workerId } = this.props;
    this.setState({
      isLoading: true
    });
    changeWorkerSkillAction({
      id: skill.id,
      user_id: workerId,
      job_skill_id: skill.job_skill_id,
      skill_level_id: this.state.skillLevel
    }).then(
      () => getWorkerSkillsAction(workerId).then(
        () => {
          this.setState({
            isEditing: false,
            isLoading: false
          });
        }
      )
    );
  };

  handleChangeSkillLevel = event => {
    const intValue = parseInt(event.target.value, 10);
    this.setState({
      skillLevel: intValue
    });
  };

  render () {
    const { skill, skillLevels } = this.props;
    const { isEditing, isLoading, skillLevel } = this.state;
    return (
      <div className='skill-wrapper'>
        <div
          className='skill-img'
          style={{ backgroundImage: `url('${skill.icon_url || defaultJobImage}')` }}
        />
        <div className='skill-info-wrapper d-flex align-items-center'>
          <div className='skill-row'>
            <p>{skill.skill_label}</p>
            { isLoading ? (
              <img className='loading-spinner' src={spinner} alt='spinner' />
            ) : (
              <Delete onClick={this.removeActiveSkill} className='ml-3' />
            )}
          </div>
          { isEditing && (
            <select
              className={'styled-select select-skill'}
              value={skillLevel}
              onChange={this.handleChangeSkillLevel}
            >
              {skillLevels.map(skillLevel =>
                <option value={skillLevel.skill_level_id} key={skillLevel.id}>
                  {skillLevel.skill_level_label}
                </option>
              )}
            </select>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/workerDetails/ActiveWorkerSkill.js